import React from "react";
import Box from "../../../elements/box/Box";
import { UserCircleIcon, RefreshIcon } from "@heroicons/react/outline";
function HistoryScoinBox(props) {
  return (
    <div className="flex flex-row">
      <Box>
        <div className="flex flex-col">
          <div className="flex flex-row items-center">
            <h3 className="text-xl font-bold">3/N/BHS/XI/XXXX</h3>

            <div className="flex flex-row mx-4">
              <UserCircleIcon className="h-6 w-6" />
              <RefreshIcon className="h-6 w-6 mx-2 text-blue-300" />
              <UserCircleIcon className="h-6 w-6" />
            </div>
          </div>

          <div className="flex flex-row items-center">
            <div className="flex flex-row gap-4 mt-6">
              <p className="text-sm text-blue-500">Sabtu, 1 Mei 2020</p>
              <p className="text-sm text-green-500">Berhasil</p>
              <p className="text-sm">Sabtu, 1 Mei 2020</p>
            </div>
          </div>

          <div className="flex flex-row gap-4 mt-6">
            <p className="text-sm">Kode: 5110</p>
            <p className="text-sm">Nominal: 200</p>
            <p className="text-sm">ID Transaksi: x-10111</p>
          </div>
        </div>
      </Box>
    </div>
  );
}

HistoryScoinBox.propTypes = {};

export default HistoryScoinBox;
